import React from "react";
import ContactComponent from "../Components/Contact";

function ContactPage() {
  return <ContactComponent />;
}

export default ContactPage;
